import React from 'react'
import { IoIosCloseCircle } from 'react-icons/io'
import SearchIcon from 'src/views/components/Icons/SearchIcon'

const SearchBar = React.forwardRef(
  (
    { value, onChange, onClear, placeholder, className = '', ...props },
    ref
  ) => (
    <div className={`search-bar-wrapper ${className}`.trim()}>
      <span className="search-bar-icon">
        <SearchIcon
          className="search-icon-svg"
          size={20}
          data-testid="qa-search-icon"
        />
      </span>
      <input
        ref={ref}
        type="text"
        className="form-control"
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        aria-label={placeholder}
        {...props}
      />
      {value ? (
        <button
          type="button"
          className="clear-search-btn"
          onClick={onClear}
          aria-label="Clear search"
          title="Clear search">
          <IoIosCloseCircle size={20} />
        </button>
      ) : null}
    </div>
  )
)

export default SearchBar
